import { sendUtagEvent } from '../../core/analytics/utag_events'

export function initializeUtagEvents(blockSelector) {
  if (!blockSelector) return

  const infoLinksWithUtagInfoMap = document.querySelectorAll(`${blockSelector} .utag-info-map-link`)

  if (infoLinksWithUtagInfoMap) {
    infoLinksWithUtagInfoMap.forEach(infoLink => {
      infoLink.addEventListener('click', () => {
        sendUtagEvent({
          data: {
            event_name: 'hotel_map',
            event_cat: 'hotel information',
            event_act: 'see map',
            event_lbl: '',
            event_purpose: 'inspiration',
            event_structure: 'popup',
          },
        })
      })
    })
  }

  const infoLinksWithUtagInfoInformation = document.querySelectorAll(`${blockSelector} .utag-info-information-link`)
  if (infoLinksWithUtagInfoInformation) {
    infoLinksWithUtagInfoInformation.forEach(infoLink => {
      infoLink.addEventListener('click', () => {
        sendUtagEvent({
          data: {
            event_name: 'hotel_services',
            event_cat: 'hotel information',
            event_act: 'see hotel info',
            event_lbl: '',
            event_purpose: 'inspiration',
            event_structure: 'popup',
          },
        })
      })
    })
  }

  const infoLinksWithUtagPhotos = document.querySelectorAll(`${blockSelector} .utag-info-photos-link`)
  if (infoLinksWithUtagPhotos) {
    infoLinksWithUtagPhotos.forEach(infoLink => {
      infoLink.addEventListener('click', () => {
        sendUtagEvent({
          data: {
            event_name: 'hotel_multimedia',
            event_cat: 'hotel information',
            event_act: 'see photos and videos',
            event_lbl: 'photos',
            event_purpose: 'inspiration',
            event_structure: 'popup',
          },
        })
      })
    })
  }
}
